let config = {
  inputLabel: 'callToAction',
  key: 'ctatext',
  inputType: 'textfield',
};

export default config;
